import '../styles/PageGlobal.css';
import './BonDeComFournisseurNewPage.css';
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { BCFService } from '../services/BCFService.js';
import { FournisseurService } from '../services/FournisseurService.js';

export default function BonDeComFournisseurNewPage() {
  const navigate = useNavigate();
  const bcfService = useMemo(() => new BCFService(), []);
  const fournisseurService = useMemo(() => new FournisseurService(), []);

  const [fournisseurs, setFournisseurs] = useState([]);
  const [supplierId, setSupplierId] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingFournisseurs, setLoadingFournisseurs] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFournisseurs = async () => {
      try {
        // 🟢 CORRECTION : Utiliser fournisseurService.getAll() au lieu de bcfService.findAll()
        const data = await fournisseurService.getAllFournisseurs();
        setFournisseurs(data || []);
      } catch (err) {
        setError("Erreur chargement fournisseurs : " + err.message);
      } finally {
        setLoadingFournisseurs(false);
      }
    };
    fetchFournisseurs();
  }, [fournisseurService]);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!supplierId) {
      alert("Veuillez sélectionner un fournisseur.");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      await bcfService.create({
        supplierId: Number(supplierId),
        status: "DRAFT"
      });
      
      // 🟢 Redirection vers la liste pour voir le nouveau BCF vide
      navigate(`/bon_com_fournisseur_list`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loadingFournisseurs) {
    return <div className="devis-status devis-status-loading">Chargement des fournisseurs…</div>;
  }

  return (
    <div className="containerMain boncomfournisseur-new-container">
      <h1 className="boncomfournisseur-title">Nouveau Bon de Commande Fournisseur</h1>
      
      {error && <div className="devis-status devis-status-error">{error}</div>}

      <form onSubmit={handleCreate} style={{ maxWidth: '500px', marginTop: '30px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Fournisseur :
          </label>
          <select
            value={supplierId}
            onChange={(e) => setSupplierId(e.target.value)}
            required
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }}
          >
            <option value="">-- Sélectionnez un fournisseur --</option>
            {fournisseurs.map(f => (
              <option key={f.id} value={f.id}>
                {f.nom || f.raisonSociale || `Fournisseur #${f.id}`} (ID: {f.id})
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button 
            type="submit" 
            className="boncomfournisseur-btn boncomfournisseur-btn-success" 
            disabled={loading || !supplierId}
            style={{ flex: 1, padding: '12px', fontSize: '16px', fontWeight: 'bold' }}
          >
            {loading ? 'Création...' : 'Créer le BCF'}
          </button>
          <button 
            type="button" 
            className="boncomfournisseur-btn boncomfournisseur-btn-grey" 
            onClick={() => navigate("/bon_com_fournisseur_list")}
            style={{ flex: 1, padding: '12px', fontSize: '16px' }}
          >
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}